import getID from './getCloudinaryID'
export default (url, width, height) => {
  if (!url.includes('cloudinary')) {
    return url
  }
  const h = height ? `h_${height}` : ''
  const w = width ? `w_${width}` : ''
  const base = 'https://res.cloudinary.com/rehabpath/image/upload'
  return `${base}/f_auto${h && `,${h}`}${w && `,${w}`}/${getID(url)}`
}
